export default __webpack_public_path__ + "static/media/asteroides1.aa3a59e2.png";